const ROUTES = new Set([null, 'settings', 'accessibility', 'security'])

export class SessionShellState {
  constructor({ onChange = () => {} } = {}) {
    this.onChange = onChange
    this.mode = 'main'
    this.route = null
    this.connection = { status: 'idle', error: null, retryAt: null }
    this.busy = null
  }

  snapshot() {
    const ready = this.connection.status === 'ready'
    return {
      mode: this.mode, route: this.route, connection: this.connection, busy: this.busy,
      visible: this.mode !== 'world', localInputPaused: this.mode !== 'world',
      canEnter: this.mode === 'main' && ready && !this.busy,
      canResume: this.mode === 'pause' && ready && !this.busy,
      canRetry: ['error', 'cancelled'].includes(this.connection.status) && !this.busy,
      canDisconnect: this.mode === 'pause' && ready && !this.busy,
    }
  }

  emit() { const value = this.snapshot(); this.onChange(value); return value }

  setConnection(value) {
    this.connection = value && typeof value === 'object' ? { status: value.status || 'idle', error: value.error || null, retryAt: value.retryAt || null } : { status: 'idle', error: null, retryAt: null }
    if (this.mode === 'pause' && this.connection.status === 'cancelled') { this.mode = 'main'; this.route = null }
    return this.emit()
  }

  enter() {
    if (!this.snapshot().canEnter) return false
    this.mode = 'world'; this.route = null; this.emit(); return true
  }

  pause() {
    if (this.mode !== 'world' || this.connection.status !== 'ready' || this.busy) return false
    this.mode = 'pause'; this.route = null; this.emit(); return true
  }

  resume() {
    if (!this.snapshot().canResume) return false
    this.mode = 'world'; this.route = null; this.emit(); return true
  }

  open(route) {
    if (!ROUTES.has(route) || this.mode === 'world') return false
    if (this.route === route) return false
    this.route = route; this.emit(); return true
  }

  closeRoute() {
    if (!this.route) return false
    this.route = null; this.emit(); return true
  }

  startAction(kind) {
    if (this.busy || !['disconnect', 'logout'].includes(kind)) return false
    this.busy = kind; this.emit(); return true
  }

  finishAction(kind, { toMain = false } = {}) {
    if (this.busy !== kind) return false
    this.busy = null
    if (toMain) { this.mode = 'main'; this.route = null }
    this.emit(); return true
  }
}
